import React from 'react';
import { Control, Controller, FieldPathByValue } from 'react-hook-form';
import { Trash2 } from 'lucide-react';

import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Checkbox } from '@/components/ui/checkbox';
import { Separator } from '@/components/ui/separator';
import { cn } from '@/lib/utils';

import { ICheckList } from '../schema';

interface IProps {
  control: Control<ICheckList>;
  name: FieldPathByValue<ICheckList, ICheckList['steps'][0]['form'][0]>;
  onRemove?: React.MouseEventHandler;
  withSeparetor?: boolean;
}

const FormEntry: React.FC<IProps> = ({
  control,
  name,
  onRemove,
  withSeparetor,
}) => (
  <div className="flex flex-col gap-4">
    {withSeparetor && <Separator />}
    <div className="flex gap-4 items-baseline">
      <FormField
        name={`${name}.name`}
        control={control}
        render={({ field }) => (
          <FormItem className="flex-1">
            <FormLabel>Nome</FormLabel>
            <FormControl>
              <Input {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        name={`${name}.type`}
        control={control}
        render={({ field }) => (
          <FormItem>
            <FormLabel>Tipo</FormLabel>
            <FormControl>
              <Select
                value={field.value}
                onValueChange={field.onChange}
                name={field.name}
              >
                <SelectTrigger className="w-[180px]">
                  <SelectValue placeholder="Select a type" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="text">Texto</SelectItem>
                  <SelectItem value="number">Numérico</SelectItem>
                  <SelectItem value="textarea">Área de texto</SelectItem>
                  <SelectItem value="checkbox">Checkbox</SelectItem>
                </SelectContent>
              </Select>
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <Controller
        control={control}
        name={`${name}.name`}
        render={({ fieldState: { invalid } }) => (
          <Button
            className={cn({ 'self-center': invalid, 'self-end': !invalid })}
            variant="destructive"
            size="icon"
            onClick={onRemove}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        )}
      />
    </div>

    <FormField
      name={`${name}.required`}
      control={control}
      render={({ field }) => (
        <FormItem className="flex items-center space-x-2">
          <FormControl>
            <Checkbox
              id={`${name}.required`}
              checked={field.value}
              onCheckedChange={field.onChange}
            />
          </FormControl>
          <FormLabel htmlFor={`${name}.required`}>Obrigatório</FormLabel>
        </FormItem>
      )}
    />
  </div>
);

export default FormEntry;
